import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Icon } from '../icon/Icon';
import styles from './shell.module.css';
export function GlobalFind({ onOpen, label }) {
    useEffect(() => {
        function onKey(e) {
            if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
                e.preventDefault();
                onOpen();
            }
        }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onOpen]);
    return (_jsxs("button", { type: "button", className: styles.find, onClick: onOpen, children: [_jsx(Icon, { name: "search" }), _jsx("span", { className: styles.findLabel, children: label ?? 'Find' }), _jsx("span", { className: styles.findKey, "aria-hidden": "true", children: "\u2318K" })] }));
}
//# sourceMappingURL=GlobalFind.js.map